/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReconcileListDto { 
    id?: number;
    accountNumber?: string | null;
    tellerName?: string | null;
    user?: string | null;
    creationTime?: string;
    totalTransactions?: string | null;
    balance?: string | null;
    userId?: number;
}

